import Vue from 'vue';
import { WorkGallery, WorkGalleryCaseStudy, WorkGalleryMap, WorkGalleryMapInfoWindow, WorkGallerySortFilters, } from './Components';
Vue.component('WorkGallery', WorkGallery);
Vue.component('WorkGalleryCaseStudy', WorkGalleryCaseStudy);
Vue.component('WorkGallerySortFilters', WorkGallerySortFilters);
Vue.component('WorkGalleryMap', WorkGalleryMap);
Vue.component('WorkGalleryMapInfoWindow', WorkGalleryMapInfoWindow);
